module.exports = __webpack_public_path__ + "img/ic_close.7594f303.svg";